import translate from '../../../i18n'
import {
  CampaignPopupStatusOptions,
  CampaignPopupUserTypeOptions,
} from '../../../pages/campaign-popups-container/constant'
import { ICampaignPopupFilterParams } from '../../../pages/campaign-popups-container/share-type'
import FormattedMessage from '../../intl/format-message'
import { SearchOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, Input, Select } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'

interface ICampaignPopupFilter {
  onSearch: (value: ICampaignPopupFilterParams) => void
  formData: ICampaignPopupFilterParams | undefined
}
const { Option } = Select

const CampaignPopupFilter = (props: ICampaignPopupFilter) => {
  const { onSearch, formData } = props
  const [form] = Form.useForm()
  useEffect(() => {
    if (formData) {
      form.setFieldsValue({
        ...formData,
        startDate: formData.startDate ? dayjs(formData.startDate) : undefined,
        endDate: formData.endDate ? dayjs(formData.endDate) : undefined,
      })
    }
  }, [formData])
  const onFinish = (values: ICampaignPopupFilterParams) => {
    onSearch({
      ...values,
      summary: values.summary ? values.summary.trim() : undefined,
      startDate: values.startDate ? dayjs(values.startDate).utc().format() : undefined,
      endDate: values.endDate ? dayjs(values.endDate).utc().format() : undefined,
    })
  }

  return (
    <Form form={form} layout="inline" className="filter-inline-form" onFinish={onFinish}>
      <Form.Item name="summary" label={`${translate('campaignPopups.summary')}`}>
        <Input placeholder={translate('campaignPopups.filterSummaryPlaceholder')} />
      </Form.Item>
      <Form.Item name="status" label={translate('campaignPopups.status')}>
        <Select style={{ minWidth: 130 }} allowClear>
          {CampaignPopupStatusOptions.map(item => {
            return (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            )
          })}
        </Select>
      </Form.Item>
      <Form.Item name="userType" label={translate('campaignPopups.userType')}>
        <Select style={{ minWidth: 130 }} allowClear>
          {CampaignPopupUserTypeOptions.map(item => {
            return (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            )
          })}
        </Select>
      </Form.Item>
      <Form.Item name="startDate" label={translate('campaignPopups.startDate')}>
        <DatePicker showTime />
      </Form.Item>
      <Form.Item name="endDate" label={translate('campaignPopups.endDate')}>
        <DatePicker showTime />
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>
          <FormattedMessage id="search"></FormattedMessage>
        </Button>
      </Form.Item>
    </Form>
  )
}

export default CampaignPopupFilter
